export default __webpack_public_path__ + "yellow_curve.dd7818.png";